import { CSSProperties, Children } from 'react'
import styled from 'styled-components'
import { browserCheck } from '@ta-interaktiv/browsercheck'
import { parseHostname } from '@ta-interaktiv/parse-hostname'
import './test.module.css'

const AnchorElement = styled.a<{ colorMode: 'light' | 'dark' }>`

`

const validURL = (str: string) => {
  const pattern = new RegExp(
    '^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$',
    'i'
  ) // fragment locator
  return !!pattern.test(str)
}
const isnum = (val: string) => {
  return /^\d+$/.test(val)
}

export interface LinkProps {
  /** Url to open  */
  href?: string
  /** Semantic Ui Icon to show, uses SVG-Icon if not provided */
  icon?: string
  /** hide the icon  */
  hideIcon?: boolean | false
  /** Link target [mobile,not mobile] */
  target?: [string, string] | string
  /** CSS-Class for Link */
  className?: string
  /** Inline css for the link */
  style?: CSSProperties
  /** Linktext */
  children?: string | JSX.Element[] | JSX.Element
  /** Linktext */
  allowWordWrap?: boolean
  /** Linktext */
  colorMode?: 'light' | 'dark'
  /** Other Props passed to the link */
  [key: string]: any // eslint-disable-line
}

/**
 * Displays a Link with Semantic-UI-Icon. The link opens in _parent on mobile and in _blank on others by default.
 *
 */

export const Stink = ({
  href = '',
  icon,
  hideIcon = false,
  target = ['_parent', '_blank'],
  className,
  style = { whiteSpace: 'nowrap' },
  children = 'Link',
  allowWordWrap = true,
  colorMode = 'light',
  ...props
}: LinkProps) => {
  /* If href is not a url, consists of onyl digits and has a length of 8 or 12 create a tenant link to current publication domanin */
  let hrefIsArticleID = false
  if (!validURL(href)) {
    const splitedParams = href.split('?')
    let url = splitedParams[0]
    let params = splitedParams[1]

    if (isnum(url) && (url.length === 8 || url.length === 12)) {
      href =
        'https://www.' +
        parseHostname().publicationDomain +
        '/' +
        url +
        (params ? '?' + params : '')
      hrefIsArticleID = true
    }
  }
  /* If children/linktext are not provided but href is provided, the href becomes the children/linktext. */
  if (children === 'Link' && href) children = href
  /* If children/linktext are not provided. Link is shown as placeholder */

  let openIn: string
  if (typeof target === 'object') {
    openIn = browserCheck.isMobile ? target[0] : target[1]
  } else {
    openIn = target
  }
  /* Do not wrap between last word an icon */
  const kids = Children.toArray(children)

  const head: any = (kids[0] as string).split(' ')
  const tail: any = (head.length > 1 ? ' ' : '') + head.pop()

  return (
    <span>
      <AnchorElement
        colorMode={colorMode}
        href={href}
        target={openIn}
        className={colorMode}
        // {...props}
        // style={{ color: '#f00' }}
      >
        {head.join(' ')}
        <span style={{ whiteSpace: 'nowrap' }}>
          {tail}
          {!hideIcon && !hrefIsArticleID && !icon && <LinkIcon />}
          {!hideIcon && !hrefIsArticleID && icon && (
            <>
              {' '}
              <i className={'icon ' + icon} style={{ fontSize: '.8em' }} />
            </>
          )}
        </span>
      </AnchorElement>
    </span>
  )
}

// Icon after link text, Icon loaded as SVG, Icon only when href is not ArticleID, allowWordWrap default to true
// Stink.defaultProps = {
//   href: '',
//   hideIcon: false,
//   target: ['_parent', '_blank'],
//   className: '',
//   style: { whiteSpace: 'nowrap' },
//   children: 'Link',
//   allowWordWrap: true,
// }

const LinkIcon = () => (
  <svg width='12px' height='14px' viewBox='0 0 12 14'>
    <title>link icon</title>
    <g
      id='1-Element/Icon/14/External_Story-Link_narrow'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
    >
      <g id='Group-2' transform='translate(0.000000, -0.000000)'>
        <rect id='Size' x='0' y='0' width='12' height='14' />
        <g
          id='Group'
          transform='translate(2.812816, -0.000000)'
          className='linkicon'
        >
          <rect id='Rectangle' x='2.18718434' y='0' width='7' height='1.5' fill='var(--text-color)'/>
          <rect
            id='Rectangle'
            transform='translate(4.419417, 4.819417) rotate(-45.000000) translate(-4.419417, -4.819417) '
            x='-1.08058262'
            y='4.06941738'
            width='11'
            height='1.5'fill='var(--text-color)'
          />
          <rect id='Rectangle' x='7.68718434' y='0' width='1.5' height='7'fill='var(--text-color)' />
        </g>
      </g>
    </g>
  </svg>
)
